import Vue from 'vue'

const savedQueriesFinancialReport = {
  state: {
    savedQueriesFinancialReport: [],
    selectedSavedQueriesFinancialReport: {},
  },

  getters: {
    savedQueriesFinancialReport(state) {
      return state.savedQueriesFinancialReport
    },
    selectedSavedQueriesFinancialReport(state) {
      return state.selectedSavedQueriesFinancialReport
    },
  },

  mutations: {
    savedQueriesFinancialReport(state, payload) {
      state.savedQueriesFinancialReport = payload
    },
    selectedSavedQueriesFinancialReport(state, payload) {
      state.selectedSavedQueriesFinancialReport = JSON.parse(
        JSON.stringify(payload)
      )
    },
  },

  actions: {
    setSelectedSavedQueriesFinancialReport(context, payload) {
      context.commit('selectedSavedQueriesFinancialReport', payload)
    },
    loadSavedQueriesFinancialReport(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'SavedQueriesFinancialReport'
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('savedQueriesFinancialReport', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    loadSelectedSavedQueriesFinancialReport(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'SavedQueriesFinancialReport/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedSavedQueriesFinancialReport', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    updateSavedQueriesFinancialReport(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `SavedQueriesFinancialReport/${payload.ID}`
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'saved query updated'},
              {root: true}
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadSavedQueriesFinancialReport')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    createSavedQueriesFinancialReport(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `SavedQueriesFinancialReport`
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'saved query created'},
              {root: true}
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadSavedQueriesFinancialReport')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    saveSavedQueriesFinancialReport(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateSavedQueriesFinancialReport', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createSavedQueriesFinancialReport', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteSavedQueriesFinancialReport(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `SavedQueriesFinancialReport/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'saved query deleted'},
              {root: true}
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadSavedQueriesFinancialReport')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
  },
}

export default savedQueriesFinancialReport
